import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { InformacionContratoBecas } from "./TypesContratoBecas";
//URL
import configData from "config.json"
import { alertService } from "components/Varios/alert_service";
import { ObtenerFechaFromIsoFormat } from "functions/DatesFunctions";


const URL_GET_CONTRATOSBECAS = "DatosContratosBeca/"

export function handleHeader(token: string) {
    return {
        'Content-Type': 'application/json',
        Authorization: `KEYESPOL ${token}`,

    }
}


export async function ObtenerContratosBecas(datosPersona: UserData) {
    var convenios: Array<InformacionContratoBecas> = []
    try {
        const respuesta = await axios.get(configData.SERVER_URL + URL_GET_CONTRATOSBECAS, {
            headers: handleHeader(datosPersona.token)
        })
        convenios = respuesta.data;
        var conveniosParse:InformacionContratoBecas[] = convenios.map((valores,indiceValores) => {
            return { ...valores,
                fechaInicioEstudio: ObtenerFechaFromIsoFormat(valores.fechaInicioEstudio),
                fechaFinEstudio: ObtenerFechaFromIsoFormat(valores.fechaFinEstudio),
                fechaFirmaContrato: ObtenerFechaFromIsoFormat(valores.fechaFirmaContrato)                
            }
        })
        convenios = conveniosParse;
    } catch (error) {
        alertService.error("Ha ocurrido un inconveniente al tratar de obtener los Contratos de Becas");
    }
    return convenios;
}

